import { render, staticRenderFns } from "./policies.kubewarden.io.admissionpolicy.vue?vue&type=template&id=11410b01&scoped=true&"
import script from "./policies.kubewarden.io.admissionpolicy.vue?vue&type=script&lang=js&"
export * from "./policies.kubewarden.io.admissionpolicy.vue?vue&type=script&lang=js&"
import style0 from "./policies.kubewarden.io.admissionpolicy.vue?vue&type=style&index=0&id=11410b01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11410b01",
  null
  
)

export default component.exports